import type { FC } from 'react'
import classNames from 'classnames'

type CellProps = React.HTMLAttributes<HTMLDivElement>

export const Cell: FC<CellProps> = (props) => {
  const { children, className, ...otherProps } = props

  return (
    <div
      {...otherProps}
      className={classNames('col-span-12 max-lg:col-span-9 max-md:col-span-7', className)}
    >
      {children}
    </div>
  )
}
